import { render, staticRenderFns } from "./IconClip.vue?vue&type=template&id=17cedc28&"
import script from "./IconClip.vue?vue&type=script&lang=js&"
export * from "./IconClip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports